export default function Gallery() {
  return (
    <div className="min-h-screen" style={{backgroundColor: '#7d688f'}}>
      <div className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="relative z-10 pb-8 bg-transparent sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
            <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              {/* Header */}
              <div className="text-center">
                <h1 className="text-4xl font-extrabold sm:text-5xl md:text-6xl" style={{color: '#a5bc8a'}}>
                  <span className="block">Photo</span>
                  <span className="block">
                    Gallery
                  </span>
                </h1>
                <p className="mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl" style={{color: '#a5bc8a'}}>
                  Here you will find a collection of our favourite moments captured during our special day.
                </p>
              </div>

              {/* Gallery Categories */}
              <div className="mt-16">
                <div className="flex justify-center space-x-4 mb-12">
                  <button className="px-6 py-2 text-white rounded-full transition-colors hover:opacity-80" style={{backgroundColor: '#a5bc8a'}}>
                    All Photos
                  </button>
                  <button className="px-6 py-2 bg-white rounded-full transition-colors hover:bg-gray-100" style={{color: '#a5bc8a'}}>
                    Engagement
                  </button>
                  <button className="px-6 py-2 bg-white rounded-full transition-colors hover:bg-gray-100" style={{color: '#a5bc8a'}}>
                    Pre-Wedding
                  </button>
                  <button className="px-6 py-2 bg-white rounded-full transition-colors hover:bg-gray-100" style={{color: '#a5bc8a'}}>
                    Ceremony
                  </button>
                </div>

                {/* Photo Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {/* Placeholder Photo Cards */}
                  {[...Array(12)].map((_, index) => (
                    <div key={index} className="group relative overflow-hidden rounded-lg shadow-lg bg-white">
                      <div className="aspect-w-1 aspect-h-1 w-full h-64 bg-gradient-to-br from-gray-200 to-gray-300 group-hover:scale-105 transition-transform duration-300">
                        <div className="flex items-center justify-center h-full">
                          <svg className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                        </div>
                      </div>
                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <button className="bg-white px-4 py-2 rounded-lg font-medium hover:bg-gray-100 transition-colors" style={{color: '#a5bc8a'}}>
                            View Photo
                          </button>
                        </div>
                      </div>
                      <div className="p-4">
                        <h3 className="text-sm font-medium" style={{color: '#a5bc8a'}}>Photo {index + 1}</h3>
                        <p className="text-xs" style={{color: '#a5bc8a', opacity: 0.7}}>Beautiful moment captured</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Story Sections */}
              <div className="mt-20 space-y-16">
                {/* Engagement Section */}
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className="md:flex">
                    <div className="md:w-1/2">
                      <div className="h-64 md:h-full flex items-center justify-center" style={{backgroundColor: '#7d688f'}}>
                        <svg className="h-16 w-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                      </div>
                    </div>
                    <div className="md:w-1/2 p-8">
                      <h2 className="text-3xl font-bold mb-4" style={{color: '#a5bc8a'}}>Our Engagement</h2>
                      <p className="leading-relaxed mb-4" style={{color: '#a5bc8a'}}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
                      </p>
                      <p className="leading-relaxed" style={{color: '#a5bc8a'}}>
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Pre-Wedding Section */}
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                  <div className="md:flex md:flex-row-reverse">
                    <div className="md:w-1/2">
                      <div className="h-64 md:h-full flex items-center justify-center" style={{backgroundColor: '#a5bc8a'}}>
                        <svg className="h-16 w-16 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                    </div>
                    <div className="md:w-1/2 p-8">
                      <h2 className="text-3xl font-bold mb-4" style={{color: '#a5bc8a'}}>Pre-Wedding Celebrations</h2>
                      <p className="leading-relaxed mb-4" style={{color: '#a5bc8a'}}>
                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.
                      </p>
                      <p className="leading-relaxed" style={{color: '#a5bc8a'}}>
                        Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Call to Action */}
              <div className="mt-20 text-center">
                <div className="rounded-lg shadow-lg p-8 text-white" style={{backgroundColor: '#a5bc8a'}}>
                  <h2 className="text-3xl font-bold mb-4">More Photos Coming Soon!</h2>
                  <p className="text-lg mb-6">
                    We're still curating the best moments from our special day. Check back soon for more beautiful memories!
                  </p>
                  <a
                    href="/"
                    className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md bg-white hover:bg-gray-50 transition-all duration-200"
                    style={{color: '#a5bc8a'}}
                  >
                    Back to Home
                    <svg className="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </a>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}